import { Dayjs } from "dayjs";
import { DayHoursList } from "src/business/restaurant/restaurant";
import {
  SLOTS_PER_DAY,
  openWindowsForDate,
  slotLabelForRow,
} from "src/components/Main/Pages/TableSchedule/dayGridHelpers";

/**
 * Today's service windows as display strings, e.g. `["12:00 – 15:00",
 * "19:00 – 00:00"]`. Empty when the restaurant is closed — a leave day, or a
 * day with no hours on record.
 */
export const openingWindowsForDate = (
  schedule: DayHoursList,
  date: Dayjs,
  leaves: string[],
): string[] =>
  openWindowsForDate(schedule, date, leaves).map(
    ({ startRow, endRow }) =>
      // A service closing at midnight ends on row 48, which wraps back to 00:00.
      `${slotLabelForRow(startRow)} – ${slotLabelForRow(
        endRow === SLOTS_PER_DAY ? 0 : endRow,
      )}`,
  );
